import React from 'react';

export const WhatsupIcon = ({
  width = '26',
  height = '26',
  fill = '#FFFFFF',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 21C16.523 21 21 16.523 21 11C21 5.477 16.523 1 11 1C5.477 1 1 5.477 1 11C1 12.379 1.28 13.693 1.784 14.888C2.063 15.548 2.202 15.878 2.22 16.128C2.237 16.378 2.163 16.652 2.016 17.201L1 21L4.799 19.984C5.348 19.837 5.622 19.764 5.872 19.78C6.122 19.798 6.452 19.937 7.112 20.216C8.34266 20.7343 9.66465 21.0009 11 21Z"
        stroke={fill}
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 21C16.523 21 21 16.523 21 11C21 5.477 16.523 1 11 1C5.477 1 1 5.477 1 11C1 12.379 1.28 13.693 1.784 14.888C2.063 15.548 2.202 15.878 2.22 16.128C2.237 16.378 2.163 16.652 2.016 17.201L1 21L4.799 19.984C5.348 19.837 5.622 19.764 5.872 19.78C6.122 19.798 6.452 19.937 7.112 20.216C8.34266 20.7343 9.66465 21.0009 11 21Z"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 21C16.523 21 21 16.523 21 11C21 5.477 16.523 1 11 1C5.477 1 1 5.477 1 11C1 12.379 1.28 13.693 1.784 14.888C2.063 15.548 2.202 15.878 2.22 16.128C2.237 16.378 2.163 16.652 2.016 17.201L1 21L4.799 19.984C5.348 19.837 5.622 19.764 5.872 19.78C6.122 19.798 6.452 19.937 7.112 20.216C8.34266 20.7343 9.66465 21.0009 11 21Z"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.58817 11.377L8.45917 10.296C8.82617 9.84 9.27917 9.416 9.31617 8.808C9.32417 8.655 9.21617 7.967 9.00117 6.59C8.91617 6.049 8.41017 6 7.97317 6C7.40317 6 7.11817 6 6.83517 6.13C6.47717 6.293 6.11017 6.752 6.02917 7.137C5.96517 7.442 6.01317 7.652 6.10817 8.072C6.51017 9.855 7.45517 11.616 8.91917 13.081C10.3842 14.545 12.1452 15.49 13.9292 15.892C14.3492 15.987 14.5582 16.035 14.8632 15.971C15.2482 15.891 15.7072 15.523 15.8712 15.165C16.0002 14.882 16.0002 14.597 16.0002 14.027C16.0002 13.589 15.9512 13.084 15.4102 12.999C14.0332 12.783 13.3452 12.676 13.1922 12.684C12.5852 12.72 12.1602 13.174 11.7042 13.541L10.6232 14.411"
        stroke={fill}
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.58817 11.377L8.45917 10.296C8.82617 9.84 9.27917 9.416 9.31617 8.808C9.32417 8.655 9.21617 7.967 9.00117 6.59C8.91617 6.049 8.41017 6 7.97317 6C7.40317 6 7.11817 6 6.83517 6.13C6.47717 6.293 6.11017 6.752 6.02917 7.137C5.96517 7.442 6.01317 7.652 6.10817 8.072C6.51017 9.855 7.45517 11.616 8.91917 13.081C10.3842 14.545 12.1452 15.49 13.9292 15.892C14.3492 15.987 14.5582 16.035 14.8632 15.971C15.2482 15.891 15.7072 15.523 15.8712 15.165C16.0002 14.882 16.0002 14.597 16.0002 14.027C16.0002 13.589 15.9512 13.084 15.4102 12.999C14.0332 12.783 13.3452 12.676 13.1922 12.684C12.5852 12.72 12.1602 13.174 11.7042 13.541L10.6232 14.411"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.58817 11.377L8.45917 10.296C8.82617 9.84 9.27917 9.416 9.31617 8.808C9.32417 8.655 9.21617 7.967 9.00117 6.59C8.91617 6.049 8.41017 6 7.97317 6C7.40317 6 7.11817 6 6.83517 6.13C6.47717 6.293 6.11017 6.752 6.02917 7.137C5.96517 7.442 6.01317 7.652 6.10817 8.072C6.51017 9.855 7.45517 11.616 8.91917 13.081C10.3842 14.545 12.1452 15.49 13.9292 15.892C14.3492 15.987 14.5582 16.035 14.8632 15.971C15.2482 15.891 15.7072 15.523 15.8712 15.165C16.0002 14.882 16.0002 14.597 16.0002 14.027C16.0002 13.589 15.9512 13.084 15.4102 12.999C14.0332 12.783 13.3452 12.676 13.1922 12.684C12.5852 12.72 12.1602 13.174 11.7042 13.541L10.6232 14.411"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
